import './styles.scss'

import React, { useState } from 'react'
import PropTypes from 'prop-types'

import stringWithWBR from 'lib/tags/string-with-wbr'
import ReadMore from 'lib/components/read-more'
import { exceedsMax } from 'lib/utils/exceeds-max'
import I18n from 'lib/i18n'

import Price from '~/scenes/course/show/price'

const MAX_LINES = 8
const MAX_HEIGHT = 176

const TitlesSection = ({ title, description, information, enablePriceModal }) => {
  const [expandedItem, setExpandedItem] = useState(null)

  const handleToggle = currentExpandableItemId => {
    setExpandedItem(previousExpandableItemId =>
      previousExpandableItemId === currentExpandableItemId ? null : currentExpandableItemId
    )
  }

  const courseDescriptionAreaExceedMax = exceedsMax('.course-description .read-more-text', MAX_HEIGHT)
  const courseExtraInformationAreaExceedMax = exceedsMax('.course-extra-informations .read-more-text', MAX_HEIGHT)

  return (
    <>
      <div className='course-title-container'>
        <div className='course-title'>{stringWithWBR(title)}</div>
        <Price onClick={enablePriceModal} />
      </div>

      <div className='course-description'>
        <ReadMore
          id='course-description'
          onToggle={handleToggle}
          isExpanded={expandedItem === 'course-description'}
          text={description}
          numberOfLines={MAX_LINES}
          noButton={!courseDescriptionAreaExceedMax}
        />
      </div>

      {information && (
        <div className='course-extra-informations'>
          <div className='extra-informations-title'>{I18n.t('courses.show.extra')}</div>
          <ReadMore
            id='course-extra-informations'
            onToggle={handleToggle}
            isExpanded={expandedItem === 'course-extra-informations'}
            text={information}
            numberOfLines={MAX_LINES}
            noButton={!courseExtraInformationAreaExceedMax}
          />
        </div>
      )}
    </>
  )
}

TitlesSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  information: PropTypes.string,
  enablePriceModal: PropTypes.func
}

export default TitlesSection
